import './TransportStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { fetchTransport } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

const TransportStatistic = ({ params }) => {
    const dispatch = useDispatch();
    const transportStatistic = useSelector((state) => state.statistic.transportStatistic);
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchTransport({ token, params }));
    }, [dispatch, token, params]);

    useEffect(() => {
        // Resize после рендера данных
        const timeout = setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 150);

        return () => clearTimeout(timeout);
    }, [transportStatistic]);

    const options = {
        title: {
            text: 'График задействованного транспорта',
            left: 'center',
            top: '5%'
        },
        tooltip: {
            trigger: 'item'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '15%',
            top: '10%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: transportStatistic.map(item => item.alias || item.name),
            axisLabel: {
                rotate: 30,
                fontSize: 10,
                interval: 0
            }
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                type: 'bar',
                data: transportStatistic.map(item => item.total_count),
                barCategoryGap: '30%',
                itemStyle: {
                    color: '#FF5722'
                }
            }
        ]
    };

    return (
        <Box className="transport_statistic">
            <ReactECharts
                ref={chartRef}
                option={options}
                style={{ width: '100%', height: '100%' }}
                notMerge={true}
                lazyUpdate={true}
            />
        </Box>
    );
};

export default TransportStatistic;